<template>
    <el-main class="pageLayoutBody">
        <div class="pageForm">
            <div class="pageFormTitle">编辑项目</div>

            <el-form ref="form" :model="form.data" :rules="rules" label-width="100px" size="small">
                <div class="detailModule">
                    <el-form-item label="项目名称：" prop="projectName">
                        <el-input v-model="form.data.projectName" placeholder="请输入个人姓名或者企业名称"></el-input>
                    </el-form-item>
                    <el-form-item label="项目类型：" prop="projectType">
                      <el-select v-model="form.data.projectType" placeholder="请选择项目类型" size="small">
                          <el-option label="企业" value="企业"></el-option>
                          <el-option label="个人" value="个人"></el-option>
                         
                      </el-select>
                    </el-form-item>

                  <el-form-item label="证件信息：" prop="certificateInfo">
                        <el-input v-model="form.data.certificateInfo" placeholder="请输入身份证或者组织机构代码"></el-input>
                    </el-form-item>
                    <el-form-item label="联系方式：" prop="phone">
                        <el-input type="number" v-model="form.data.phone" placeholder="请输入联系方式"></el-input>
                    </el-form-item>
                   <el-form-item label="业务类型：" prop="businessTypeId">
                       <!-- <el-checkbox-group v-model="form.data.businessTypeId">
                           <el-checkbox v-for="(item, i) in typeList" :key="i" :label="item.id">{{item.name}}</el-checkbox>
                       </el-checkbox-group> -->

                       <el-select v-model="form.data.businessTypeId" placeholder="请选择业务类型" size="small">
                          <el-option v-for="(item, i) in typeList" :key="i" :label="item.name" :value="`${item.name}|${item.id}`"></el-option>
                      </el-select>

                    </el-form-item>
                    <el-form-item label="借款金额：" prop="loanAmount">
                        <el-input type="number" v-model="form.data.loanAmount" placeholder="请输入借款金额">
                          <template slot="append">万元</template>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="借款期限：" prop="loanLife">
                        <el-input type="number" v-model="form.data.loanLife" placeholder="请输入借款期限">
                          <template slot="append">月</template></el-input>
                    </el-form-item>
                    <el-form-item label="备注说明：" >
                        <el-input v-model="form.data.remark" placeholder="请输入备注说明"></el-input>
                    </el-form-item>
                    <el-form-item label="已上传文件：" >
                        <el-button type="primary" @click="downloadFile">点击下载</el-button>
                    </el-form-item>
                     <el-form-item label="所需资料：" >
                           <div class = "text">具体所需提交的材料，请联络与您对接的渠道经理<br><span>注：请按要求准备好相关资料后打包上传</span></div>
                         <input type="file" name='upFile' id="upFile" @change='changeFile($event)' accept=".zip, .rar, .7z" ref="qiniuFile"/>
                    
                        <el-button type="primary" class="formBtn"  @click="uploadFile()" :loading="isSubmitLoading">从新上传</el-button>
                       
                    </el-form-item>

                </div>
                <el-form-item style="padding-left: 16px">
                     <el-button class="formBtn" :loading="isSubmitLoading" @click="submitForm('form')">保存</el-button>
                    <el-button class="formBtn" @click="$router.go(-1)">取消</el-button>
                    <el-button type="primary" class="formBtn" :loading="isSubmitLoading" @click="submitExamine('form')">提交</el-button>
                </el-form-item>
            </el-form>
        </div>
    </el-main>
</template>

<script>
  import * as qiniu from "qiniu-js";
  import {getTypePartner} from "../../../../api/business";
  import {putClientEdit,getClientDetail,getQiniuYun,putClientEditUp} from "../../../../api/client";

  export default {
    name: "clientBankEdit",
    data () {
      return {
         filePercent:0,
        file:null,
        baseurl:' https://img.yc8879.com/',
        token:'',
        form: {
          appId: "",
          data: {
            id: this.$route.query.id,
            businessTypeId: '',
            businessTypeName: '',
            certificateInfo: "",
            fileData: "",
            loanAmount: '',
            loanLife: '',
            phone: "",
            projectName: "",
            projectType: "",
            remark: ""
          },
          encData: "",
          encType: "",
          extra: {},
          signData: "",
          signType: "",
          timestamp: "",
          version: ""
        },
        rules: {
          projectName: [
            { required: true, message: '请输入个人姓名或者企业名称', trigger: 'blur' }
          ],
          projectType: [
            { required: true, message: '请输入项目类型', trigger: 'blur' }
          ],
          certificateInfo: [
            { required: true, message: '请输入身份证或者组织机构代码', trigger: 'blur' },
            { min: 1, max: 18, message: '请输入有效身份证或者组织机构代码', trigger: 'blur' }
          ],
          phone: [
            { required: true, message: '请输入联系方式', trigger: 'blur' }
          ],
          businessTypeId: [
            { required: true, message: '请输入业务类型', trigger: 'blur' }
          ],
          loanAmount: [
            { required: true, message: '请输入借款金额', trigger: 'blur' }
          ],
          loanLife: [
            { required: true, message: '请输入借款期限', trigger: 'blur' }
          ],
         
        },
        isSubmitLoading: false,
        typeList: []
      }
    },
    created() {
      this.getTypeList();
      this.getInfo();
       this.getToken()
    },
    methods: {
      downloadFile(){
          var url = this.form.data.fileData
          window.location.href =url
      },
      changeCheckbox(val){
        console.log(this.form.data.businessTypeId)
        console.log(val)
        
      },
      getToken(){
         getQiniuYun({fileName:'file'}).then(res => {
          if (res.code == 0) {
            console.log(res)
            this.token = res.data
          }
        })
      },
      handlePreview(file) {
        console.log(file);
        console.log(this.file);
        
      },
      handleExceed(files, fileList) {
        this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
      },
      uploadFile() {
        if(this.file==null||this.file==''){
          this.$message({
            message: '请选择上传资料',
            type: 'error',
        
          })
          return false
        }
        console.log(this.file)
       var that =  this;
        this.isSubmitLoading = true
    // 当前VUE中的this 是指向实例，相当于父级，指向指不到子级中。所需需要一个变量 _this 存储this得指向。
      let _this = this       
    // 获取身份的token
      let token = _this.token
      
    // 上传时的配置
      var config = {
        useCdnDomain: true,
      };
    //  设置文件的配置
      var putExtra = {
        fname: "",
        params: {},
        mimeType: null
      };
      console.log(this.file)
      let key = 'finance/'+this.file.name
    
    //   实例化七牛云的上传实例
      var observable = qiniu.upload(_this.file, key, token, putExtra, config);
      console.log(observable)
      
    //   设置实例的监听对象
      var observer = {
        //   接收上传进度信息
        next(res) {
            // 上传进度
            console.log(res);
            _this.filePercent = parseInt(res.total.percent) 
            if(_this.filePercent==100){
               that.isSubmitLoading = false
               
                that.$message({
                  message: '上传成功',
                  type: 'success',
              
                });
            } 
        },
        // 接收上传错误信息
        error(err) {
          console.log(err)
          that.isSubmitLoading = false
          if(err.code==614){
               that.$message({
                  message: '上传失败，请勿重复上传，请修改后上传',
                  type: 'error',
                });
          }
        },
 
        // 接收上传完成后的信息
        complete(res) {
             // 拼接路径字符串
          that.isSubmitLoading = false
             console.log(res)
             _this.form.data.fileData = _this.baseurl+res.key
            
        }
      };
      // 上传开始
      var subscription = observable.subscribe(observer); 
     
      console.log(subscription)
    },
    

      changeFile(e){
    //   获取文件
      var size = e.target.files[0].size;
      console.log(size);
      if(size>1024*1024*10){
        this.file ='';
          this.$message({
              message: '请上传不大于10M的压缩文件，具体文件内容请与业务经理沟通确认',
              type: 'error',
          });
          this.$refs.qiniuFile.value = '';
      }else{
        this.file = e.target.files[0];
      }
    
    },
      getInfo(){
        var id = this.$route.query.id;
        getClientDetail(id).then(res => {
          console.log(res)
          if (res.code == 0) {
            this.form.data.projectName = res.data.projectName
            this.form.data.projectType = res.data.projectType
            this.form.data.certificateInfo = res.data.certificateInfo
            this.form.data.phone = res.data.phone
            this.form.data.loanAmount = res.data.loanAmount
            this.form.data.loanLife = res.data.loanLife
            this.form.data.remark = res.data.remark
            this.form.data.fileData = res.data.fileData

            this.form.data.businessTypeId = res.data.businessTypeName+'|'+res.data.businessTypeId
          }
        })
      },
      getTypeList () {
        getTypePartner().then(res => {
          if (res.code == 0) {
            this.typeList = res.data
          }
        })
      },
      submitForm (formName) {
        this.$refs[formName].validate(valid => {
          if (valid) {
            var businessNameId =this.form.data.businessTypeId.split("|");
            this.isSubmitLoading = true
            this.form.data.loanAmount = parseFloat(this.form.data.loanAmount);
            this.form.data.loanLife = parseInt(this.form.data.loanLife);
            this.form.data.businessTypeName = businessNameId[0];
            this.form.data.businessTypeId = parseInt(businessNameId[1]);
            console.log(this.form)
            
            putClientEdit(this.form).then(res => {
              this.isSubmitLoading = false
              console.log(res)
              if (res.code == 0) {
                this.$message({
                  message: '修改成功',
                  type: 'success',
                  showClose: true,
                });
                this.$router.go(-1)
              }
              else{
                this.form.data.businessTypeId = this.form.data.businessTypeName+'|'+this.form.data.businessTypeId;
              }
            }).catch(() => {
              this.isSubmitLoading = false
            })
           
          }
        })
      },

      submitExamine(formName) {
        this.$refs[formName].validate(valid => {
          if (valid) {        
            if(this.form.data.fileData==''){
              this.$message({
                  message: '请上传资料',
                  type: 'error',
              })
              this.isSubmitLoading = false
              return false
            }
            var businessNameId =this.form.data.businessTypeId.split("|");
            console.log(businessNameId)
            this.isSubmitLoading = true
            this.form.data.loanAmount = parseFloat(this.form.data.loanAmount);
            this.form.data.loanLife = parseInt(this.form.data.loanLife);
            this.form.data.businessTypeName = businessNameId[0];
            this.form.data.businessTypeId = parseInt(businessNameId[1]);

            console.log(this.form)
            putClientEditUp(this.form).then(res => {
              this.isSubmitLoading = false
              console.log(res)
              if (res.code == 0) {
                this.$message({
                  message: '创建成功',
                  type: 'success',
                  showClose: true,
                });
                this.$router.go(-1)
              }
              else{
                this.form.data.businessTypeId = this.form.data.businessTypeName+'|'+this.form.data.businessTypeId;
              }
            }).catch(() => {
              this.isSubmitLoading = false
            })
           
          }
        })
      }







    },
    components: {
    }
  }
</script>
<style scoped>
.text{
  margin-top: 5px;
  line-height: 150%;
  margin-bottom: 12px;
}
.text span{
  color:#666;
 font-size: 12px;
}
</style>